module.exports = "https://cdn-challenge.mathletics.com/app/107/assets/images/392e3ce79efd83e0e7878ed22344be35.svg";